import React from 'react'
import RingSpinner from './RingSpinner'

const SIZE_PRESETS = {
  small: 18,
  medium: 30,
  large: 48,
  xlarge: 84,
}

export function resolveSpinnerSize({ size, fontSize } = {}) {
  if (typeof size === `number`) {
    return size
  }
  if (typeof fontSize === `number`) {
    return fontSize
  }
  if (typeof size === `string` && SIZE_PRESETS[size]) {
    return SIZE_PRESETS[size]
  }
  return SIZE_PRESETS.medium
}

/**
 * Spinner unificado de la app (anillo SACI).
 * La factura animada se usa solo en ModalSpiner al procesar documentos.
 */
export default function Spinner({ size, fontSize, className }) {
  return (
    <RingSpinner
      size={resolveSpinnerSize({ size, fontSize })}
      className={className}
    />
  )
}

/** Centrado para Suspense y secciones que cargan lazy (no pantalla completa). */
export function SpinnerFallback({
  size = `large`,
  minHeight = 160,
  className = ``,
}) {
  return (
    <div
      className={`spinner-fallback ${className}`.trim()}
      style={{ minHeight }}
      role="status"
      aria-label="Cargando"
    >
      <Spinner size={size} />
    </div>
  )
}
